.itemPrice {
  display: flex;
  flex-direction: inherit;
  align-items: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;

  @media (min-width: 601px) {
    justify-content: space-between;
  }

  &.verbose {
    column-gap: inherit;

    &.list {
      .previous {
        text-decoration: line-through;
        text-decoration-color: var(--neutral-500);
        text-decoration-thickness: 0.0625rem;

        @media (min-width: 1025px) {
          text-decoration: none;
        }

        .prefix {
          display: none;

          @media (min-width: 1025px) {
            display: inline;
          }
        }
      }
    }
  }

  &.numeric {
    column-gap: 0.375rem;

    .previous {
      position: relative;
      bottom: 0.0625rem;
      text-decoration: line-through;
      text-decoration-color: var(--neutral-500);
      text-decoration-thickness: 0.0625rem;
    }
  }

  .current,
  .previous {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .current {
    flex: 0 0 auto;
  }

  .previous {
    text-decoration: line-through;
    text-decoration-color: var(--neutral-500);
    text-decoration-thickness: 0.0625rem;

    @media (min-width: 601px) {
      flex: 1 1 auto;
      text-align: right;
      text-decoration: none;
    }

    .prefix {
      display: none;

      @media (min-width: 601px) {
        display: inline;
      }
    }
  }
}
